import React from 'react';
import DashboardContentView from './DashboardContentView';
import DashboardWebsocket from './DashboardWebsocket';

const DashboardContent = () => {
  return (
    <>
      <DashboardWebsocket />
      <DashboardContentView />
    </>
  );
};

export default DashboardContent;
